import type { Amenity, AmenityCategory } from '@interfaces/amenity.interface';

import { mockDb } from '../mock-db';

export function getAmenitiesByCategoryMock(): AmenityCategory[] {
  return mockDb.getAmenityCategories();
}

export function getAmenityByIdMock(id: string): Amenity | undefined {
  return mockDb.getAmenityById(id);
}

export function createAmenityMock(data?: Partial<Amenity>): Amenity {
  const base = mockDb.getAmenityCategories()[0]?.data[0];
  return { ...base, id: `amenity-${Date.now()}`, ...data };
}

export function updateAmenityMock(id: string, data: Partial<Amenity>): Amenity {
  const existing = mockDb.getAmenityById(id);
  const base = existing ?? mockDb.getAmenityCategories()[0]?.data[0];
  return { ...base, id, ...data };
}

export function deleteAmenityMock(): { success: boolean } {
  return { success: true };
}
